import { BehaviorSubject, merge, NEVER } from 'rxjs';
import { ElementRef } from '@angular/core';
import { switchMap, mapTo, debounceTime } from 'rxjs/operators';
import { ContentObserver } from '@angular/cdk/observers';

/** Extends content observer so that if there is no element a result of null is still observered. */
export class ElementSafeObserver {
  private elemSubject = new BehaviorSubject<ElementRef | undefined>(undefined);

  /** The element being observerd. */
  get element() { return this.elemSubject.value; }
  set element(elemRef: ElementRef | undefined) {
    if (elemRef !== this.elemSubject.value) {
      this.elemSubject.next(elemRef);
    }
  }

  /** fires every time the element is changed or mutated.  Returning the element.  Can be undefined. */
  readonly elem$ = merge(
    this.elemSubject,
    this.elemSubject.pipe(
      switchMap(x => !x ? NEVER : this.contentObserver.observe(x).pipe(mapTo(x)))
    )
  ).pipe(debounceTime(0));

  constructor(private contentObserver: ContentObserver) {}
}
